import { useRouter } from 'next/router';
import React, { type FC, useEffect, useState } from 'react';
import { Button } from '@/DesignSystem/Component';
import { enqueueError } from '@/Module/Core/Helper';
import { Logo } from '@/Module/DefaultLayout/Component';
const RubikaLogout: FC = () => {
  const router = useRouter();
  const result = router.query?.result as string || '';
  const message: Record<string, string> = {
    canCloseTab: 'کاربر گرامی، اعتبار توکن شما به پایان رسیده، لطفاً از برنامه خارج شده و مجدداً از روبیکا وارد شوید.',
    canNotCloseTab: 'کاربر گرامی، اعتبار توکن شما به پایان رسیده، لطفاً این پنجره را بسته و مجدداً از روبیکا وارد شوید.'
  };
  const [canCloseTab, setCanCloseTab] = useState(false);
  const handleCloseTab = () => {
    if (typeof window !== 'undefined' && window.opener) {
      window.close();
    } else {
      enqueueError('لطفاً این تب را به صورت دستی ببندید.');
    }
  };
  useEffect(() => {
    // Disable scrolling when the component mounts
    document.body.style.overflow = 'hidden';
    if (typeof window !== 'undefined' && window.opener) setCanCloseTab(true);
    // Cleanup to re-enable scrolling when the component unmounts
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return <div className="fixed left-0 top-0 z-[200] flex h-screen w-screen flex-col items-center justify-center bg-white" data-sentry-component="RubikaLogout" data-sentry-source-file="RubikaLogout.tsx">
      <div className="fixed left-0 top-0 flex h-20 w-full flex-col items-center justify-center border-4 border-blueFive bg-blueSeven text-white">
        <Logo data-sentry-element="Logo" data-sentry-source-file="RubikaLogout.tsx" />
      </div>
      {canCloseTab ? <div className="flex flex-col items-center justify-center px-4">
          <p className="px-8 text-center text-lg drop-shadow-lightBlue">{message.canCloseTab}</p>
          <Button className="mt-8 w-72" variant="shadow" color="primary" onClick={handleCloseTab}>
            خروج از آی‌نو
          </Button>
        </div> : <p className="px-14 text-center text-lg drop-shadow-lightBlue">{message[result] ?? message.canNotCloseTab}</p>}
    </div>;
};
export default RubikaLogout;